import React, { PropTypes } from "react";

const CurrentWebinarsView = ({
  webinars,
  nextPage,
  pagination,
  count,
  onRefreshWebinars,
  // is_admin,
  // notification_enabled,
  // onFieldChange,
  // novonordiskSubscribed,
  // toggleNovonordiskSubscription
}) => (
  <div>
    {/*{!is_admin &&*/}
    {/*<div className="email_notification_sponsor">*/}
    {/*  <FormControlLabel*/}
    {/*    control={*/}
    {/*      <Checkbox*/}
    {/*        checked={novonordiskSubscribed}*/}
    {/*        name='subscription_sponsor'*/}
    {/*        onChange={() => toggleNovonordiskSubscription({*/}
    {/*          target: {*/}
    {/*            name: 'novonordiskSubscribed', value: !novonordiskSubscribed*/}
    {/*          }*/}
    {/*        })}*/}
    {/*      />*/}
    {/*    }*/}
    {/*    label={<span className="email_notification_label">*/}
    {/*      <span>Check the box if you like to be kept informed about future Masterclasses from<span className='novo_nordisk_text'>Novo Nordisk</span> </span>*/}
    {/*              </span>}*/}
    {/*  />*/}
    {/*</div>*/}
    {/*}*/}

    <div className="container_current row">{webinars}</div>
    {pagination && (
      <a className="more_item" href="javascript:void(0)" onClick={nextPage}>
        LOAD MORE
      </a>
    )}
    {!webinars.length && (
      <div>
        <p className="group-no-webinars">
          There are no webinars currently running click below to refresh
        </p>
        <p className="group-no-webinars">
          Please{" "}
          <span
            className="group-no-webinars-refresh"
            onClick={onRefreshWebinars}
          >
            click here
          </span>{" "}
          to refresh
        </p>
      </div>
    )}
  </div>
);

CurrentWebinarsView.propTypes = {
  webinar: PropTypes.obj,
  joinToWebinar: PropTypes.func,
};

export default CurrentWebinarsView;



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Current/CurrentWebinarsView.js